module.exports = __webpack_public_path__ + "static/media/qualifications.4434fce2.jpeg";